"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnboardingQuestionStepDtoOptionSourceEnum = exports.OnboardingQuestionStepDtoFooterEnum = exports.OnboardingQuestionStepDtoSelectionModeEnum = exports.OnboardingQuestionStepDtoInputTypeEnum = void 0;
exports.instanceOfOnboardingQuestionStepDto = instanceOfOnboardingQuestionStepDto;
exports.OnboardingQuestionStepDtoFromJSON = OnboardingQuestionStepDtoFromJSON;
exports.OnboardingQuestionStepDtoFromJSONTyped = OnboardingQuestionStepDtoFromJSONTyped;
exports.OnboardingQuestionStepDtoToJSON = OnboardingQuestionStepDtoToJSON;
exports.OnboardingQuestionStepDtoToJSONTyped = OnboardingQuestionStepDtoToJSONTyped;
var DigestCopyDto_1 = require("./DigestCopyDto");
var DigestStepVisibilityDto_1 = require("./DigestStepVisibilityDto");
var OnboardingQuestionOptionDto_1 = require("./OnboardingQuestionOptionDto");
/**
 * @export
 */
exports.OnboardingQuestionStepDtoInputTypeEnum = {
    Chips: 'chips',
    SearchChips: 'searchChips',
    TeamCardGrid: 'teamCardGrid'
};
/**
 * @export
 */
exports.OnboardingQuestionStepDtoSelectionModeEnum = {
    Single: 'single',
    Multi: 'multi'
};
/**
 * @export
 */
exports.OnboardingQuestionStepDtoFooterEnum = {
    SkipAndContinue: 'skipAndContinue',
    ContinueOnly: 'continueOnly'
};
/**
 * @export
 */
exports.OnboardingQuestionStepDtoOptionSourceEnum = {
    Static: 'static',
    Teams: 'teams',
    Players: 'players'
};
/**
 * Check if a given object implements the OnboardingQuestionStepDto interface.
 */
function instanceOfOnboardingQuestionStepDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('dimension' in value) || value['dimension'] === undefined)
        return false;
    if (!('question' in value) || value['question'] === undefined)
        return false;
    if (!('inputType' in value) || value['inputType'] === undefined)
        return false;
    if (!('selectionMode' in value) || value['selectionMode'] === undefined)
        return false;
    if (!('required' in value) || value['required'] === undefined)
        return false;
    if (!('skippable' in value) || value['skippable'] === undefined)
        return false;
    if (!('footer' in value) || value['footer'] === undefined)
        return false;
    if (!('options' in value) || value['options'] === undefined)
        return false;
    return true;
}
function OnboardingQuestionStepDtoFromJSON(json) {
    return OnboardingQuestionStepDtoFromJSONTyped(json, false);
}
function OnboardingQuestionStepDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'dimension': json['dimension'],
        'question': (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['question']),
        'sectionLabel': json['sectionLabel'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['sectionLabel']),
        'instruction': json['instruction'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['instruction']),
        'inputType': json['inputType'],
        'selectionMode': json['selectionMode'],
        'required': json['required'],
        'skippable': json['skippable'],
        'showSelectAll': json['showSelectAll'] == null ? undefined : json['showSelectAll'],
        'footer': json['footer'],
        'optionSource': json['optionSource'] == null ? undefined : json['optionSource'],
        'optionsDependsOnStepId': json['optionsDependsOnStepId'] == null ? undefined : json['optionsDependsOnStepId'],
        'optionsDependsOnStepIds': json['optionsDependsOnStepIds'] == null ? undefined : json['optionsDependsOnStepIds'],
        'fixedLeagueCodes': json['fixedLeagueCodes'] == null ? undefined : json['fixedLeagueCodes'],
        'playersSearchEndpoint': json['playersSearchEndpoint'] == null ? undefined : json['playersSearchEndpoint'],
        'teamsSearchEndpoint': json['teamsSearchEndpoint'] == null ? undefined : json['teamsSearchEndpoint'],
        'visibility': json['visibility'] == null ? undefined : (0, DigestStepVisibilityDto_1.DigestStepVisibilityDtoFromJSON)(json['visibility']),
        'searchPlaceholder': json['searchPlaceholder'] == null ? undefined : (0, DigestCopyDto_1.DigestCopyDtoFromJSON)(json['searchPlaceholder']),
        'options': (json['options'].map(OnboardingQuestionOptionDto_1.OnboardingQuestionOptionDtoFromJSON)),
    };
}
function OnboardingQuestionStepDtoToJSON(json) {
    return OnboardingQuestionStepDtoToJSONTyped(json, false);
}
function OnboardingQuestionStepDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'dimension': value['dimension'],
        'question': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['question']),
        'sectionLabel': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['sectionLabel']),
        'instruction': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['instruction']),
        'inputType': value['inputType'],
        'selectionMode': value['selectionMode'],
        'required': value['required'],
        'skippable': value['skippable'],
        'showSelectAll': value['showSelectAll'],
        'footer': value['footer'],
        'optionSource': value['optionSource'],
        'optionsDependsOnStepId': value['optionsDependsOnStepId'],
        'optionsDependsOnStepIds': value['optionsDependsOnStepIds'],
        'fixedLeagueCodes': value['fixedLeagueCodes'],
        'playersSearchEndpoint': value['playersSearchEndpoint'],
        'teamsSearchEndpoint': value['teamsSearchEndpoint'],
        'visibility': (0, DigestStepVisibilityDto_1.DigestStepVisibilityDtoToJSON)(value['visibility']),
        'searchPlaceholder': (0, DigestCopyDto_1.DigestCopyDtoToJSON)(value['searchPlaceholder']),
        'options': (value['options'].map(OnboardingQuestionOptionDto_1.OnboardingQuestionOptionDtoToJSON)),
    };
}
